

exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-wallet-components/src/add-card/directive');

require('xo-validation/dist/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-page-components/src/value-props/directive');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/checkout/index');

var _squid = require('squid');

var _choice = require('xo-models/src/choice');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},

    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $CheckoutCartModel, $fiMessages) {
        // eslint-disable-line max-params,no-shadow
        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };

        var models = {};

        $populate(models, {
            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            payee: $CheckoutPayeeModel.instance($scope.token),
            cart: $CheckoutCartModel.instance($scope.token)
        }).then(function () {

            var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);

            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
            if (!message && models.checkoutSession.get('errorData.cause') && $stateParams.message !== 'NEED_DEBIT_CARD') {
                message = $fiMessages.errorMsg(models.payee.isGambling());
            }

            $scope.message = undefined;
            $scope.cart = models.cart;

            if (message) {
                $scope.message = {
                    type: 'info',
                    msgs: [message.msg]
                };
            }

            // Set ShowCancel if selectFi variant, to cancel to the Select Fi page
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                // Show selectFi features if no contingency
                if (selectFiVariants.indexOf(variant) !== -1 && !message) {
                    $scope.showCancel = true;
                    $scope.callbacks.cancel = function () {
                        $state.go('checkout.selectFi');
                    };
                    $scope.pagetitle = $locale.content.get('addCard.addACard');
                }
            });
        });

        $scope.isUpdateDebitCard = function () {
            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
    }
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_squid.$Component;

_squid.$config;

_choice.$ChoiceEligibility;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/directive.js
// module id = ./pages/xo-add-card/directive.js
// module chunks = 1